import PropTypes from 'prop-types';

export const PartContent = (props) => {
    return props.children;
};

PartContent.propTypes = {
    children: PropTypes.array.isRequired
};
